let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("aZinD"), load("f8xBv")]).then(() => parcelRequire('21rGX'));